<template>
  <div class="login-mask" v-if="showLoginModal">
    <div class="login-content-wrapper">
      <span class="login-close-btn" @click="hide"></span>
      <div class="login-content-info">
        <p class="login-subtitle" role="welcome">{{ i18n.t('welcome') }}</p>
        <!--        <img src="~img/logo-visa.svg" alt="logo" class="login-logo" />-->
        <img src="~img/visa-airport-companion.svg" alt="visa airport companion" class="login-cmp" />
        <p class="login-desc" role="Enjoy a unique and seamless airport experience">
          {{ i18n.t('login-desc') }}
        </p>
      </div>
      <div class="login-content">
        <div class="login-form">
          <!-- login 邮件输入框 -->
          <div class="login-email-group">
            <div class="email-input-img">
              <img class="email-logo" src="~img/email.png" alt="email logo" />
              <input
                class="login-form-item item-email fs-mask"
                :class="{ 'input-border-err': infoErr }"
                :type="showEmail"
                name="email"
                :placeholder="i18n.t('username')"
                autocomplete="off"
                role="input email"
                v-model.trim="formData.username"
                @keyup.enter="handleLogin"
                @input="handleValueChange($event)"
              />
              <img
                v-show="showEm"
                class="eye"
                src="~img/icon-feather-eye-off.svg"
                @click="emailStatus('password')"
                alt="hide password"
              />
              <img
                v-show="showEmTxt"
                class="eye"
                src="~img/icon-feather-eye-on.svg"
                @click="emailStatus('text')"
                alt="show password"
              />
            </div>
          </div>
          <!-- login 密码输入框 -->
          <div class="login-password-group">
            <div class="password-input-img">
              <img class="password-logo" src="~img/lock.png" alt="password logo" />
              <input
                class="login-form-item item-password fs-mask"
                :class="{ 'input-border-err': infoErr }"
                :type="showPassword"
                name="password"
                :placeholder="i18n.t('login-password')"
                autocomplete="off"
                role="input password"
                v-model="formData.password"
                @keyup.enter="handleLogin"
              />
            </div>
            <img
              v-show="showPd"
              class="eye"
              src="~img/icon-feather-eye-off.svg"
              @click="passwordStatus('password')"
              alt="hide password"
            />
            <img
              v-show="showTxt"
              class="eye"
              src="~img/icon-feather-eye-on.svg"
              @click="passwordStatus('text')"
              alt="show password"
            />
          </div>
          <!-- login 错误提示 -->
          <p v-if="infoErr" class="error-message">{{ errorMsg }}</p>
        </div>

        <div class="login-forget">
          <a class="forget-password" role="link" @click="handleLinkClick('/reset-pwd')">
            {{ i18n.t('login-forgot') }}
          </a>

          <div class="login-btn" :class="{ 'login-btn-disable': loginDisable }">
            <div v-if="!loading" @click="handleLogin" role="button">
              {{ i18n.t('login') }}
            </div>
            <img v-else class="btn-loading" src="~img/loading.gif" alt="" />
          </div>
          <span class="login-line"></span>
        </div>

        <div class="login-buttom">
          <span class="new-user"> {{ i18n.t('user') }}&nbsp; </span>
          <button class="sign-up" role="button sign up" @click="handleLinkClick('/sign-up')">
            {{ i18n.t('signup') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // 解决获取不到$t的问题
  import i18n from '@/i18n/index';
  // 解决获取不到$router的问题
  import router from '@/router';
  import store from '@/store';
  import verify from '@/utils/verify';
  // import { mapMutations } from 'vuex';
  // import { mapActions } from 'vuex';
  // 非响应式数据不需要放在data中，提升性能
  const deviceName = JSON.parse(localStorage.getItem('currentDeviceName'));
  export default {
    name: 'LoginModal',

    props: {
      showLoginModal: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        i18n,
        infoErr: false,
        loading: false,
        formData: {
          username: '',
          password: '',
          version: '1.0.0',
          device: 'web',
          deviceName,
        },
        loginDisable: true,
        showPassword: 'password',
        showEmail: 'text',
        errorMsg: '',
      };
    },

    computed: {
      showEm() {
        if (this.showEmail === 'password') {
          return true;
        }
        return false;
      },
      showEmTxt() {
        if (this.showEmail === 'text') {
          return true;
        }
        return false;
      },
      showPd() {
        if (this.showPassword === 'password') {
          return true;
        }
        return false;
      },
      showTxt() {
        if (this.showPassword === 'text') {
          return true;
        }
        return false;
      },
    },

    watch: {
      formData: {
        handler(newVal) {
          if (newVal.username && newVal.password) {
            this.loginDisable = false;
          } else {
            this.loginDisable = true;
          }
          if (newVal.username) {
            this.infoErr = false;
            this.errorMsg = '';
          }
          if (newVal.password) {
            this.infoErr = false;
            this.errorMsg = '';
          }
        },
        deep: true,
      },

      showLoginModal(newVal) {
        if (!newVal) {
          this.resetForm();
        }
      },
    },

    methods: {
      passwordStatus(data) {
        this.showPassword = data === 'password' ? 'text' : 'password';
      },
      emailStatus(data) {
        this.showEmail = data === 'password' ? 'text' : 'password';
      },

      hide() {
        if (this.loading) return;
        this.showLoginModal = false;
        // 顶号的时候，需要刷新banner。如果在Home页面观测isLogin，每次弹出被顶号弹窗后就会马上刷新页面
      },

      show() {
        this.showLoginModal = true;
      },

      handleLogin() {
        if (this.loginDisable) return;
        verify({ username: this.formData.username }).then(errMsg => {
          if (errMsg.pass) {
            store
              .dispatch('loginModule/login', { ...this.formData, lang: i18n.locale })
              .then(res => {
                if (res.state === '11') {
                  const afterLoginRouter = sessionStorage.getItem('afterLoginRouter');
                  router.push(afterLoginRouter);
                  this.$loginModal.hide();
                  if (router.currentRoute.name === 'SignUp') {
                    router.push('/');
                  }
                  const { ingenicoType } = res.user;
                  /* 登录时 ingenicoType === 2 登录成功 */
                  /* 登录时 ingenicoType === 0 重新验证用户已绑定的卡 获取前6的接口 补全卡号  web端没有该逻辑，忽略，算登录成功 */
                  if (ingenicoType !== 1) {
                    // 登录成功
                    location.reload();
                  }
                  /* 登录时 ingenicoType === 1 验证新的卡 */
                  if (ingenicoType === 1) {
                    // 跳转至update页面，并且此时保持未登录状态
                    this.$messageModal.show({
                      image: false,
                      closeIcon: false,
                      title: 'update-tip-title',
                      desc: 'update-tip-desc',
                      confirmBtn: 'OK',
                      justHide: true,
                      i18nNeed: true,
                      successCallback: () => this.$loginModal.showUpload(),
                    });
                  }
                  /*
              TODO: 距离上次登录超过24小时的话需要做VCES校验(后台校验后返回字段给前端做交互) 插件不能用this.setState
            */
                  if (res.vcesCheckResult === 1) {
                    store.commit('setState', {
                      state: 'vcesStatus',
                      values: 1,
                    });
                    sessionStorage.setItem('vcesStatus', 1);
                  } else if (res.vcesCheckResult === 2) {
                    store.commit('setState', {
                      state: 'vcesStatus',
                      values: 2,
                    });
                    sessionStorage.setItem('vcesStatus', 2);
                  } else {
                    store.commit('setState', {
                      state: 'vcesStatus',
                      values: 0,
                    });
                    sessionStorage.setItem('vcesStatus', 0);
                  }
                } else if (res.state === '00') {
                  this.infoErr = true;
                  this.errorMsg = res.note;
                }
              })
              .catch(err => {
                console.log('login err', err);
              });
          } else {
            this.infoErr = true;
            this.errorMsg = errMsg[0].errMessage;
          }
        });
      },

      handleLinkClick(path) {
        router.push(path);
        this.$loginModal.hide();
      },

      resetForm() {
        this.formData = {
          username: '',
          password: '',
          version: '1.0.0',
          device: 'web',
          deviceName,
        };
        this.infoErr = false;
        this.errorMsg = '';
        this.showPassword = 'password';
      },

      handleValueChange(e) {
        const { value } = e.target;
        this.formData.username = value.replace(/\s+/g, '');
      },

      // TODO: 之后找时间确认为什么这种方式会报错 => dispatch = undefined
      // ...mapActions('loginModule', ['login']),
    },
  };
</script>

<style lang="scss" scoped>
  @use 'index.scss';
</style>
